import React, { FunctionComponent } from 'react';
import { Input } from '@vwfs-bronson/bronson-react';
import { FieldInputProps } from 'formik';
import { t } from 'i18next';
import { FormField } from '../FormField/FormField';
import { FormFieldPropsBase } from './formfields.model';

export type StaticTextFormFieldProps = FormFieldPropsBase & { displayValue?: string };

export const StaticTextFormField: FunctionComponent<StaticTextFormFieldProps> = ({
  labelTranslationKey = '',
  placeholderTranslationKey = '',
  fieldName,
  testId,
  infoTextTranslationKey,
  addonSpinner,
  displayValue,
  isDisabled = true,
  isReadonly,
}): React.JSX.Element => {
  return (
    <FormField
      type="input"
      name={fieldName}
      required
      testId={testId ?? fieldName}
      labelText={`${t(labelTranslationKey)}`}
      infoText={infoTextTranslationKey ? t(infoTextTranslationKey) : ''}
      render={(fieldProps: FieldInputProps<any>) => (
        <Input
          {...fieldProps}
          disabled={isDisabled}
          readOnly={isReadonly && !isDisabled}
          aria-disabled
          placeholder={t(placeholderTranslationKey)}
          value={displayValue}
          addonSpinner={addonSpinner}
        />
      )}
    />
  );
};
